import { IEscrowBankAccountResponse } from '../../types/accounting/response/IEscrowBankAccountResponse';

export const getEscrowBankAccountLabel = (
  escrowBankAccount: IEscrowBankAccountResponse,
  isSpruceWithZillowEnabled: boolean,
  isZillowClosingEnabled: boolean
): string => {
  const baseName = isSpruceWithZillowEnabled ? escrowBankAccount.legalName : escrowBankAccount.spruceName;
  const selectedNickname = isZillowClosingEnabled ? escrowBankAccount.nickname : escrowBankAccount.spruceNickname;
  const displayName = selectedNickname ? `${baseName} ${selectedNickname}` : baseName;
  return [escrowBankAccount.stateAbbreviation, escrowBankAccount.purpose, displayName].join(' ');
};
